'use strict';

function fixInnerIssue () {
  var removeExtLinks = $('#pdf-header').hasClass('remove-links');
  var $logo = $('#company-logo');
  var marginTop = (220 - ($logo.height() + 8)) / 2;
  var $dirs = $('#criterium-local_directories .directory-container');

  $('.criterium-content .table td img').attr('style', '');

  $('.criterium-advice').each(function () {
    var textTmp = $(this).text().replace(/^\s+|\s+$/g, '');

    if (textTmp === '') {
      return $(this).remove();
    }
  });

  $('.quick-links a').each(function () {
    var classTmp = $(this).attr('class');

    $(this).parent().append('<span class="' + classTmp + '"></span>');
    return $(this).remove();
  });

  $('body a.js-ext-link').each(function () {
    var $this = $(this).removeClass('js-ext-link');
    var currentHref = '' + $this.attr('href');
    var newHref = currentHref.replace('ext://', 'http://');

    return $this.attr('href', newHref);
  });

  if (removeExtLinks) {
    $('a').each(function () {
      var $anchor = $(this);
      var href = $anchor.attr('href') || '';

      if (/^https?:\/\/.*/.test(href)) {
        return $anchor.attr('href', '#').addClass('removed-ext-href');
      }
    });
  }

  $(
    '#criterium-19 table th:nth-child(3),' +
    '#criterium-19 table td:nth-child(3)'
  ).remove();

  $('#toc>div').each(function () {
    var $this = $(this);

    if ($this.children().length === 0) {
      return $this.remove();
    }
  });

  $('#report-content>.module').each(function () {
    var $this = $(this);
    var $child = $this.find('.criterium:not(.hidden)');
    if ($child.length === 0) {
      $this.hide();
    }
    if (!$this.is(':visible')) {
      return $('#toc #' + $this.attr('id') + '-link').hide();
    }
  });

  $logo.css('margin-top', marginTop + 'px');

  if ($dirs.length <= 0) {
    return $dirs.remove();
  }
}

module.exports = fixInnerIssue;
